import { widget } from "@foretagsplatsen/widgetjs";
import sectionWidget from "../widgets/sectionWidget.js";
import state from "../state.js";

/**
 * `document` is the common abstract superclass for all
 * documents.
 *
 * TODO: should be abstract, but since many documents just instantiate it
 * (function old style inheritance), we obviously can't do it.
 */

export default widget.subclass((that, my) => {
	my.initialize = function (spec) {
		my.super(spec);
		// empty, updating, loaded (#default)
		my.state = state.loaded;
	};

	that.onUpdateActions = my.events.createEvent();
	that.onShowActions = my.events.createEvent();
	that.onHideActions = my.events.createEvent();

	that.updateDocumentContent = function () {
		that.update();

		// eslint-disable-next-line no-shadow -- bad practice, we should fix this
		const stateClasses = state.allStates.map((state) => state.label);

		that.asJQuery()
			.find("#document")
			.removeClass(stateClasses)
			.addClass(my.state.label);
	};

	that.showEmpty = function () {
		my.setState(state.empty);
	};

	that.showUpdating = function () {
		my.setState(state.updating);
	};

	that.showContent = function () {
		my.setState(state.loaded);
	};

	/**
	 * Returns true if the actions menu should be visible only for
	 * mobile devices.
	 */
	that.isActionsMenuMobileOnly = function () {
		return false;
	};

	/**
	 * Returns true if the receiver has a actions menu. If false, no
	 * actions menu or menu toggler will be rendered.
	 */
	that.hasActionsMenu = function () {
		return false;
	};

	/**
	 * Returns true if the actions menu should be wider than the default.
	 */
	that.hasWideActionsMenu = function () {
		return false;
	};

	/**
	 * Returns true if a navigation menu should be displayed when
	 * setting the document.
	 */
	that.hasNavigation = function () {
		return false;
	};

	/**
	 * Returns true if a header menu should be displayed when
	 * setting the document.
	 */
	that.hasHeader = function () {
		return false;
	};

	that.shouldFitViewport = function () {
		return false;
	};

	that.renderContentOn = function (html) {
		html.div({ id: "document" }, my.renderDocumentContentOn);
	};

	that.renderActionsOn = function (html) {
		my.renderActionsOn(html);
	};

	that.renderTopActionsOn = () => {};

	that.shouldNotifyAlerts = function () {
		return true;
	};

	my.renderContentOn = () => {};
	my.renderUpdatingContentOn = () => {};
	my.renderEmptyContentOn = () => {};

	my.renderActionsOn = () => {};

	my.renderDocumentContentOn = function (html) {
		// Dispatch the rendering to the state since it is the one knowing how to
		my.state.renderDocumentOn(my, html);
	};

	/**
	 * Builds a `sectionWidget` widget, within one full column, and return
	 * it.
	 */
	my.section = function (options) {
		return sectionWidget(options);
	};

	// eslint-disable-next-line no-shadow -- bad practice, we should fix this
	my.setState = function (state) {
		my.state = state;
		that.trigger("stateChanged", my.state.label);
		that.updateDocumentContent();
	};

	my.updateActions = function () {
		that.onUpdateActions.trigger();
	};

	my.showActions = function () {
		that.onShowActions.trigger();
	};

	my.hideActions = function () {
		that.onHideActions.trigger();
	};
});
